/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import ChoiceButtons from 'shared/ui/components/form-components/ChoiceButtons.vue';
import DatetimePicker from 'shared/ui/components/form-components/pickers/DatetimePicker.vue';

const __vue_script__ = {
    name: 'UpdateReminderModal',

    components: {
        ChoiceButtons,
        DatetimePicker,
    },

    props: {
        type: {
            type: String,
            required: true
        },

        config: {
            type: Object,
            required: true
        },

        saveHandler: {
            type: Function,
            required: false,
            default: () => {},
        },
    },

    data() {

        return {
            submitting: false,
            innerValue: {
                ...this.config,
            },
            datePickerTime: this.formatTimeToLocale(this.config.time),
            whens: [
                {
                    value: 'same_day',
                    label: this.$t('meetings.settings.communication.reminders.same_day'),
                },
                {
                    value: 'day_before',
                    label: this.$t('meetings.settings.communication.reminders.day_before'),
                }
            ],
        };
    },

    computed: {
        timePickerFormat() {
            return this.$utils.time.getBrowserDateFormat(this.$i18n.locale, 'LT');
        }
    },

    methods: {
        async submit() {
            try {
                this.submitting = true;

                // convert time to 24h
                const parsed = moment(this.datePickerTime, [this.timePickerFormat, 'HH:mm', 'h:mm A', 'h:mm a'], true);
                if (parsed.isValid()) {
                    this.innerValue.time = parsed.format('HH:mm');
                }

                await this.saveHandler(this.innerValue);

                this.$emit('close');

            } catch (e) {
                console.error('[UpdateReminderModal] saveHandler error.', e);
            } finally {
                this.submitting = false;
            }
        },

        /**
         * @param {'{string}:{string}'} time
         */
        formatTimeToLocale(time) {
            const [hours, minutes] = time.split(':').map(Number);

            return this.$utils.time.formatTime({
                hours,
                minutes,
                format: 'LT',
            });
        },
    },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "update-reminder modal-wrapper" }, [
    _c("div", { staticClass: "modal-header" }, [
      _c("span", {
        staticClass: "close",
        on: {
          click: function ($event) {
            return _vm.$emit("close")
          },
        },
      }),
      _c("h3", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "meetings.settings.communication.reminders.update_" +
                _vm.type +
                "_title"
            )
          )
        ),
      ]),
    ]),
    _c("div", { staticClass: "modal-body" }, [
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "meetings.settings.communication.reminders.update_" +
                _vm.type +
                "_body"
            )
          )
        ),
      ]),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("choice-buttons", {
            attrs: {
              name: "reminder_when",
              options: _vm.whens,
              label: _vm.$t("meetings.settings.communication.reminders.when"),
            },
            scopedSlots: _vm._u([
              {
                key: "choice",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    item.value === "same_day"
                      ? _c("i", { staticClass: "ic-calendar-agenda" })
                      : _vm._e(),
                    item.value === "day_before"
                      ? _c("i", { staticClass: "ic-restore" })
                      : _vm._e(),
                    _c("span", { staticClass: "text" }, [
                      _vm._v(_vm._s(_vm.$t(item.label))),
                    ]),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.innerValue.when,
              callback: function ($$v) {
                _vm.$set(_vm.innerValue, "when", $$v)
              },
              expression: "innerValue.when",
            },
          }),
          _c("div", { staticClass: "sending-time" }, [
            _c("label", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "meetings.settings.communication.reminders.sending_time_summary_label"
                  )
                )
              ),
            ]),
            _c(
              "div",
              { staticClass: "time-select" },
              [
                _c("datetime-picker", {
                  attrs: {
                    clearable: false,
                    label: _vm.$t(
                      "meetings.settings.communication.reminders.sending_time"
                    ),
                    "minute-step": 5,
                    format: _vm.timePickerFormat,
                    name: "time",
                    type: "time",
                    "value-type": "format",
                  },
                  model: {
                    value: _vm.datePickerTime,
                    callback: function ($$v) {
                      _vm.datePickerTime = $$v
                    },
                    expression: "datePickerTime",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "time-summary" }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "meetings.settings.communication.reminders.sending_time_summary_desc",
                      [
                        _vm.datePickerTime,
                        _vm
                          .$t(
                            "meetings.settings.communication.reminders." +
                              _vm.innerValue.when
                          )
                          .toLocaleLowerCase(),
                      ]
                    )
                  )
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "footer",
        { staticClass: "actions", attrs: { slot: "bottom" }, slot: "bottom" },
        [
          _c(
            "button",
            {
              staticClass: "btn",
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("general.cancel")))]
          ),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { disabled: _vm.submitting },
              on: { click: _vm.submit },
            },
            [_vm._v(_vm._s(_vm.$t("general.save")))]
          ),
        ]
      ),
    ]),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/reminders/UpdateReminderModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__